import { ResourceActivityResourceType } from '@/types';

import { apiClient } from '../http';

export type ResourceAssociationLocationType = 'comments' | 'content' | 'primary-resource' | 'resource-details';

export interface ResourceAssociationLocation {
    id: string;
    label: string;
    mentionCount: number;
    type: ResourceAssociationLocationType;
}

export interface ResourceAssociationItem {
    id: string;
    locations: ResourceAssociationLocation[];
    resource: {
        href?: string;
        id: string;
        label: string;
        resourceType: ResourceActivityResourceType;
        updatedAt?: string;
        website?: string;
    };
}

export interface ResourceAssociationsResponse {
    items: ResourceAssociationItem[];
    referencedBy: ResourceAssociationItem[];
    total: number;
}

export const resourceAssociationService = {
    list: (resourceType: ResourceActivityResourceType, resourceId: string) =>
        apiClient.get<ResourceAssociationsResponse>(`/api/resource-associations/${resourceType}/${resourceId}`),
};
